import React from 'react'
import { Currency, Document, Languages, PrivacyPolicy, Share, Smallarw } from '../../../assests/ExportImageIcon'

const APP_PREFERENCES = [
    { icon: Languages, title: 'Language', subtitle: 'English (USA)', key: 'language' },
    { icon: Currency, title: 'Currency', subtitle: 'Indian Rupee (INR)', key: 'currency' },
]

const QUICK_ACTIONS = [
    { icon: Share, title: 'Share App', subtitle: 'Invite your friends' },
]

const LEGAL_ABOUT = [
    { icon: Document, title: 'Terms of Service', key: 'terms-service' },
    { icon: PrivacyPolicy, title: 'Privacy Policy', key: 'privacy-policy' },
]

const SettingGroup = ({ items, onSelect }) => (
    <div className='bgWhite commonBorder borderRadius20'>
        {items.map((item, index) => (
            <div
                className='securityMenuItem'
                key={index}
                onClick={item.key ? () => onSelect(item.key) : undefined}
            >
                <span className='securityMenuItem__icon'>
                    <img src={item.icon} alt="" />
                </span>
                <div className='securityMenuItem__info'>
                    <div className='securityMenuItem__title'>{item.title}</div>
                    {item.subtitle && <div className='securityMenuItem__subtitle'>{item.subtitle}</div>}
                </div>
                <img src={Smallarw} alt="" className='securityMenuItem__arrow' />
            </div>
        ))}
    </div>
)

const Setting = ({ onSelect }) => {
    return (
        <div className='mainSetting'>
            <div className='bsSectionTitle'>App Preferences</div>
            <SettingGroup items={APP_PREFERENCES} onSelect={onSelect} />

            <div className='bsSectionTitle mt-4'>Quick Actions</div>
            <SettingGroup items={QUICK_ACTIONS} onSelect={onSelect} />

            <div className='bsSectionTitle mt-4'>Legal &amp; About</div>
            <SettingGroup items={LEGAL_ABOUT} onSelect={onSelect} />

            <button type='button' className='travellerAddBtn tripDocCancelBtn mt-4'>Deactivate Account</button>
        </div>
    )
}

export default Setting
